import React, { useState } from 'react';
import FsLightbox from 'fslightbox-react';

import './FullscreenImage.css';

export default function FullscreenImage({ image, altText }) {
  const [toggler, setToggler] = useState(false);

  return (
    <>
      <button
        className='fullscreen-image-button'
        onClick={() => setToggler(!toggler)}
      >
        <img className='fullscreen-image' src={image} alt={altText} />
      </button>
      <FsLightbox
        toggler={toggler}
        sources={[<img src={image} alt={altText} />]}
      />
    </>
  );
}
